import { createHookWithCallbacks } from '@move-frontend/auth';
import { signInWithCallbacks } from './signInWithCallbacks';

export const useSignInWithCallbacks =
	createHookWithCallbacks(signInWithCallbacks);
